<div class="copy-badge" *ngIf="policyId">
  <div class="copy-text">{{ policyId }}</div>
  <app-copy-icon
    class="clickable"
    width="16px"
    height="16px"
    color="#475467"
    (click)="copy()"
  />
</div>
